// test1228
(1228 && 0);
